import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { useStaticTableDataStore, useUserInfoStore, type CurrentCurrency } from 'store'
import { CheckIcon, InputView } from 'ui-components'
import { DefineComponentProps } from 'utils'
import './MobileChangeCurrency.scss'

type MobileChangeCurrencyProps = {
  onCurrencyChange?: (item: ApiResponse.StaticCurrency) => void
}

export const MobileChangeCurrency = defineComponent<MobileChangeCurrencyProps>({
  props: DefineComponentProps<MobileChangeCurrencyProps>(['onCurrencyChange']),
  setup(props) {
    const { t } = useI18n()
    const staticTableDataStore = useStaticTableDataStore()
    const userInfoStore = useUserInfoStore()
    const searchValue = ref('')
    const currencyList = computed(() => {
      return staticTableDataStore.currencyList.filter((item) => {
        if (!searchValue.value) return true
        return item.logicName.toLowerCase().includes(searchValue.value.toLowerCase())
      })
    })

    const onCurrencyChange = (item: ApiResponse.StaticCurrency) => {
      userInfoStore.setToCurrency(item.logicName as CurrentCurrency<keyof ApiResponse.OtcCoinRate>)
      props.onCurrencyChange?.(item)
    }

    return () => (
      <div class="mobile-change-currency-layout">
        <InputView v-model={searchValue.value} placeholder={t('搜索法币')} />
        <div class="currency-list">
          {currencyList.value.map((item) => {
            return (
              <div key={item.logicName} class={classNames('currency-item', { active: item.logicName === userInfoStore.currentToCurrency })} onClick={() => onCurrencyChange(item)}>
                <span class="currency-item-name">
                  {item.mark}
                  &nbsp;
                  {item.abbreviate}
                </span>
                {item.logicName === userInfoStore.currentToCurrency && <CheckIcon />}
              </div>
            )
          })}
        </div>
      </div>
    )
  },
})
